import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CalibrationHrComment } from "alloy-performance-engine-cl";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { ApeCalibrationHrCommentComponent } from "../ape-calibration-hr-comment/ape-calibration-hr-comment.component";

/**
 * Il drawer con il solo Commento di HR, aperto dalla voce "Commento di HR" del pulsante Azione
 * della lista di monitoraggio (spec Monitoraggio §7 e §9.5)
 *
 * Chiudendo il drawer — con la X, con Esc o con un clic all'esterno — il testo non salvato viene
 * salvato prima di emettere la chiusura.
 */
@Component({
  selector: "ape-calibration-hr-comment-drawer",
  standalone: true,
  imports: [
    CommonModule, ApeDrawerComponent, ApeCalibrationHrCommentComponent
  ],
  templateUrl: "./ape-calibration-hr-comment-drawer.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApeCalibrationHrCommentDrawerComponent {
  protected readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  @Input() visible: boolean = false;

  @Input() processId: string = "";

  @Input() userId: string = "";

  /** Il nominativo del collaboratore, sotto il titolo */
  @Input() userFullName: string = "";

  @Output() close = new EventEmitter<void>();

  /** Il commento dopo ogni salvataggio, per aggiornare la voce di menu della lista */
  @Output() saved = new EventEmitter<CalibrationHrComment>();

  @ViewChild(ApeCalibrationHrCommentComponent) private hrComment?: ApeCalibrationHrCommentComponent;

  /** Evita la doppia chiusura: il drawer notifica sia il cambio di visibilita' sia la chiusura */
  private closing: boolean = false;

  protected async onCloseRequested(): Promise<void> {
    if (this.closing || !this.visible) {
      return;
    }
    this.closing = true;
    try {
      await this.hrComment?.flushPendingChanges();
    } finally {
      this.closing = false;
      this.close.emit();
    }
  }
}
